module.exports = __webpack_public_path__ + "static/media/home-card2.2bab6498.png";